import { pipe } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

function equivalentJson(current?: any, previous?: any): boolean {
  return JSON.stringify(current || {}) === JSON.stringify(previous || {});
}

// eslint-disable-next-line max-len
export const distinctUntilPropertiesChanged = <T>() => pipe(distinctUntilChanged<T>(equivalentJson));
